let uniqueIdCount = 0;

export default {
  isUndefined(value) {
    return !value && value !== 0 && value !== false;
  },
  isNotUndefined(value) {
    return !!value || value === 0 || value === false;
  },
  valueOrUndefined(value) {
    return this.isNotUndefined(value) ? value : undefined;
  },
  isEmptyString(value) {
    return value !== undefined && value.toString().trim() === '';
  },
  parseIntoString(value) {
    return typeof value !== 'string' ? JSON.stringify(value) : value;
  },
  // Combines a 'DD.MM.YYYY' date and an 'HH:mm' time into a Date,
  // or null if either is missing/invalid.
  toDateTime(date, time) {
    if (!date || !time) return null;
    const dateTime = moment(`${date} ${time}`, 'DD.MM.YYYY HH:mm', true);
    return dateTime.isValid() ? dateTime.toDate() : null;
  },
  debounce(fn, delay) {
    let timerId;
    return function debounced(...args) {
      clearTimeout(timerId);
      timerId = setTimeout(() => {
        fn.apply(this, args);
      }, delay);
    };
  },
  fileIconByType(fileExtension) {
    // Strip query params (e.g. "file.png?token=abc") before extracting extension
    switch (fileExtension.split('?')[0].split('.').pop().toLowerCase()) {
      case 'png':
      case 'jpg':
      case 'jpeg':
      case 'gif':
      case 'svg': return 'fa-file-image';
      case 'pdf': return 'fa-file-pdf';
      case 'csv': return 'fa-file-csv';
      case 'xlsx': return 'fa-file-excel';
      case 'zip': return 'fa-file-archive';
      default: return 'fa-file';
    }
  },
  setFontPublic(font, baseBackendUrl) {
    if (font && baseBackendUrl) {
      const link = document.createElement('link');
      link.setAttribute('type', 'text/css');
      link.setAttribute('rel', 'stylesheet');
      link.setAttribute('href', `${baseBackendUrl}/static/template-assets/styles/${font}`);
      document.head.appendChild(link);
    }
  },
  uniqueId(prefix = '') {
    uniqueIdCount += 1;
    return `${prefix}${uniqueIdCount}`;
  },
  parseNumberOrString(value) {
    if (value === null || value === undefined) return value;
    if (typeof value === 'string' && value.trim() === '') return value;
    const number = Number(value);
    return !Number.isNaN(number) ? number : value;
  },
  generateUniqueId(length = 8) {
    return Math.random().toString(36).substring(2, 2 + length);
  },
  changeFavicon(faviconPath) {
    const favicon = document.getElementById('favicon');
    if (!favicon) return;

    // If faviconPath is truthy, use it; otherwise, use the hardcoded default.
    // This handles null, undefined, or empty strings from the API.
    favicon.href = faviconPath || '/favicon.ico';
  },
  getSubdomainName() {
    return window.location.host.split('.')[1] ? window.location.host.split('.')[0] : 'rent';
  },
  handleDoubleTopLevelDomain(baseApiUrl) {
    // Update base api url with project type domain
    if (baseApiUrl && baseApiUrl.includes('[project_type_domain]')) {
      const domain = window.location.hostname.split('.').slice(-1)[0];
      baseApiUrl = baseApiUrl.replace('[project_type_domain]', domain);
    } else if (baseApiUrl.includes('[double_top_level_domain]')) {
      const doubleDomain = window.location.hostname.split('.').slice(-2).join('.');
      baseApiUrl = baseApiUrl.replace('[double_top_level_domain]', doubleDomain);
    }
    return baseApiUrl;
  },
  charStringToNumber(val, character) {
    return (val && parseInt(val.toString().replaceAll(character, ''), 10)) || null;
  },
  numberSeparator(val, charLength, separator) {
    const pattern = `\\B(?=(\\d{${charLength}})+(?!\\d))`;
    const regEx = new RegExp(pattern, 'g');
    if (!val) return '';
    return val.toString().replace(/\D/g, '').replace(regEx, separator);
  },
  getFileExtension(fileUrl) {
    if (!fileUrl) return '';
    // Strip query params (e.g. "file.png?token=abc") before extracting extension
    return fileUrl.split('?')[0].split('.').pop();
  },
  checkProjectTypeFromUrl(projectType) {
    const { host } = window.location;
    return host.includes(projectType);
  },
  // Loop over object of objcts and return only object that has prop
  getFilteredValues(objects, prop) {
    return Object.values(objects).filter((obj) => obj?.[prop]);
  },
  isEvery(value, array = []) {
    return array.every((item) => item === value);
  },
  // Remove duplicates from array of strings
  // e.g. ['string_1', 'string_2', 'string_3','string_3', 'string_3', 'string_1', 'string_2'];
  removeStringDuplicates(arr) {
    return [...new Set(arr)];
  },
};
